module.exports = __webpack_public_path__ + "static/media/my-user-bg.5e2eb6d3.svg";